import React, { useEffect, useRef, useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, Tooltip, DropdownItem, Input, Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import cx from "classnames";
import Select, { components } from "react-select";
import PropTypes from "prop-types";
import global from "../../scss/dhp.scss";
import LoadFlagImage from "./LoadFlagImage";
import { Icon } from "./icon";
import CompanyLoader from "./loader/companyLoader";

let style = Object.assign({}, global);

const selectStyles = {
  control: provided => ({
    ...provided,
    minWidth: 240,
    margin: 8,
    flexDirection: "row-reverse",
    paddingLeft: "5px",
  }),
};

const hideSearchStyle = {
  control: provided => ({
    ...provided,
    display: "none",
  }),
};

const Select2 = ({
  updateState,
  customLabel,
  labelField,
  subField,
  isDisabled,
  dropDownMenuClass,
  container,
  customDropdownMenuClass,
  showCustomInputOption = false,
  isLoading = false,
  closeOnScroll = false,
  ...props
}) => {
  const DropdownIndicatorComponent = props.manageItemLink
    ? ({ ...customProps }) => (
        <DropdownIndicator
          {...customProps}
          manageItemLink={props.manageItemLink}
          manageItemText={props.manageItemText}
          isSuperAdmin={props.isSuperAdmin}
        />
      )
    : DropdownIndicator;

  const dropdownRef = useRef(null);

  const [value, setValue] = useState(props?.defaultValue);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [customInputValue, setCustomInputValue] = useState();

  const onSelectChange = value => {
    toggle();
    if (props?.target !== "filter_records") setValue(value);
    if (subField) updateState(value, props.name, subField);
    else updateState(value, props.name);
  };

  // For reposition dropdown list on user input when position is top
  const onSearchChange = e => {
    let optionPosition = e.target.closest(".searchList-area");
    const transform = optionPosition.style.transform;
    const re = /translate3d\((?<x>.*?)px, (?<y>.*?)px, (?<z>.*?)px/;
    const results = re.exec(transform);
    if (results.groups.y < 0) {
      setTimeout(() => {
        optionPosition.style.transform = `translate3d(0px, -${optionPosition.offsetHeight + 8}px, 0px)`;
      }, 3);
    }

    // Reset custom input position on serch change
    if (showCustomInputOption) resetCustomInputPosition();
  };

  // const resetCustomInputPosition = () => {
  //   setTimeout(() => {
  //     let optionPosition = dropdownRef.current?.menuRef?.current;
  //     if (!optionPosition) return;
  //     let searchBoxStyle = optionPosition.getBoundingClientRect();
  //     if (!searchBoxStyle) return;
  //     let searchBoxHeight = searchBoxStyle.height > 0 ? searchBoxStyle.height : 11;
  //     let selectMenu = optionPosition.querySelector(".select__menu");
  //     if (!selectMenu) return;
  //     let selectMenuStyle = selectMenu.getBoundingClientRect();
  //     let customInputBox = optionPosition.querySelector(".select2-custom-input-field");
  //     let calculatedTop = searchBoxHeight + selectMenuStyle.height - 6;
  //     if (customInputBox) customInputBox.style.top = `${calculatedTop}px`;
  //   }, 10);
  // };

  const resetCustomInputPosition = (retries = 10) => {
    const checkAndPosition = (attempt = 0) => {
      setTimeout(() => {
        let optionPosition = dropdownRef.current?.menuRef?.current;
        if (!optionPosition) {
          if (attempt < retries) checkAndPosition(attempt + 1);
          return;
        }

        let searchBoxStyle = optionPosition.getBoundingClientRect();
        if (!searchBoxStyle) {
          if (attempt < retries) checkAndPosition(attempt + 1);
          return;
        }

        let searchBoxHeight = searchBoxStyle.height > 0 ? searchBoxStyle.height : 11;
        let selectMenu = optionPosition.querySelector(".select__menu");
        if (!selectMenu) {
          if (attempt < retries) checkAndPosition(attempt + 1);
          return;
        }

        let selectMenuStyle = selectMenu.getBoundingClientRect();
        let customInputBox = optionPosition.querySelector(".select2-custom-input-field");

        // Keep retrying if customInputBox is not found
        if (!customInputBox) {
          if (attempt < retries) {
            checkAndPosition(attempt + 1);
          }
          return;
        }

        // Execute the positioning code only when customInputBox is available
        let calculatedTop = searchBoxHeight + selectMenuStyle.height - 6;
        customInputBox.style.top = `${calculatedTop}px`;
      }, 10 * (attempt + 1)); // Increasing delay with each attempt
    };

    checkAndPosition(0);
  };

  const getTranslateX = el => {
      const transform = window.getComputedStyle(el).transform;
      if (!transform || transform === "none") return 0;

      const match = transform.match(/matrix.*\((.+)\)/);
      if (!match) return 0;

      const values = match[1].split(", ");
      return parseFloat(values[4]);
    };

    const getTranslateY = el => {
      const transform = window.getComputedStyle(el).transform;
      if (!transform || transform === "none") return 0;

      const match = transform.match(/matrix\((.+)\)/);
      if (!match) return 0;

      const values = match[1].split(", ");
      return parseFloat(values[5]);
    };  

  const handleMenuOpen = () => {
    setTimeout(() => {
      const currentDropdown = document.querySelectorAll(".searchList-area.show")[0];
      if (currentDropdown) {
        const selectedEl = currentDropdown.getElementsByClassName("select__option--is-selected")[0];
        const isBulkAddModal = document.querySelector(".BulkAdd-table");
        if (selectedEl && !isBulkAddModal) {
          selectedEl.scrollIntoView({ block: "nearest", inline: "start" });
        } else if (selectedEl && isBulkAddModal) {
          selectedEl.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
        // Check if menu has placed top of the dropdown and container present
        if (dropdownRef.current && dropdownRef.current.menuRef.current && container) {
          const parentDropdown = dropdownRef.current.containerRef.current;
          const menuElement = dropdownRef.current.menuRef.current;

          const targetClasses = ["new-release-type-dropdownmenu", "manager-user-modal-dropdown", "manager-user-modal-dropdown-username"];

          const hasNewReleaseClass = targetClasses.some(className => menuElement?.classList?.contains(className));

          const parentDropdownStyle = parentDropdown.getBoundingClientRect();
          const menuElementStyle = menuElement.getBoundingClientRect();
          const leftDifference = Math.round(menuElementStyle.left) - Math.round(parentDropdownStyle.left);
          const currentX = getTranslateX(menuElement);
          if (menuElementStyle?.top < parentDropdownStyle?.top) {
            let calculatedTop = parentDropdownStyle.top + parentDropdownStyle.height + 2;

            if (hasNewReleaseClass) {
              menuElement.style.transform = `translate3d(${currentX - leftDifference}px, ${calculatedTop}px, 0px)`;
              menuElement.style.position = "fixed";
            } else {
              menuElement.style.transform = `translate3d(${menuElementStyle.left}px, ${calculatedTop}px, 0px)`;
            }
            menuElement.style.opacity = 1;
          } else {
            if (hasNewReleaseClass) {
              //For manager setting New tag 
              const currentY = getTranslateY(menuElement);
              menuElement.style.transform = `translate3d(${currentX - leftDifference}px, ${currentY}px, 0px)`;
            }
          }
          menuElement.style.opacity = 1;
        }
        // Reset custom input position on serch change
        if (showCustomInputOption) resetCustomInputPosition();
      }
    }, 15);
  };

  // const stylesToApply = props.options?.length === 1 || props?.hideSearch ? hideSearchStyle : selectStyles;
  const stylesToApply = selectStyles;

  const toggle = e => {
    if (e?.target?.id === "select2-custom-input-box") {
      resetCustomInputPosition();
      return;
    }
    setDropdownOpen(prevState => !prevState);
  };

  // Below code for custom dropdown value input
  const insertCustomInputValue = e => {
    setCustomInputValue(e.target.value);
  };

  const updateDropdownCustomValue = () => {
    updateState({ name: customInputValue }, props.name);
    setCustomInputValue();
  };

  const handleEnterPress = e => {
    if (e?.key === "Enter") {
      updateState({ name: customInputValue }, props.name);
      setCustomInputValue();
      toggle();
    }
  };

  useEffect(() => {
    if (props.options?.length > 0 && showCustomInputOption) resetCustomInputPosition();
  }, [props.options]);

  useEffect(() => {
    if (dropdownOpen) handleMenuOpen(); // To fix reset dropdown scrolled position
  }, [dropdownOpen]);

  useEffect(() => {
    setValue(props?.defaultValue);
  }, [props?.defaultValue]);

  useEffect(() => {
    if (closeOnScroll) {
      const hideDropdownOnScroll = e => {
        if (e.target.classList.contains("select__menu-list")) return;
        if (dropdownOpen) toggle(e);
      };
      document.addEventListener("scroll", hideDropdownOnScroll, true);
      return () => {
        document.removeEventListener("scroll", hideDropdownOnScroll, true);
      };
    }
  }, [dropdownOpen]);

  return (
    <Dropdown
      ref={dropdownRef}
      isOpen={dropdownOpen}
      toggle={toggle}
      className={cx(style["custom_select2"], {[style["disable"]] : props?.urlDisabled})}
      disabled={isDisabled}>
      <DropdownToggle className={cx(style["w-100"], { [style[dropDownMenuClass]]: dropDownMenuClass })}>
        {value ? (
          <SelectLabel
            customLabel={customLabel}
            customDropdownMenuClass={customDropdownMenuClass}
            labelField={labelField}
            buttonValue={value}
          />
        ) : (
          "\u00A0"
        )}
        <Icon icon="ui-arrow-down" />
      </DropdownToggle>
      <DropdownMenu
        className={`searchList-area p-0 border-0 ${dropDownMenuClass ?? ""} ${
          customDropdownMenuClass ? customDropdownMenuClass : ""
        } ${container ? "overflow-dropdown-menu" : ""}`}
        container={container ? container : undefined}
        style={container && { opacity: 0 }}>
        {/* Showing loader if isLoading mode */}
        {isLoading && <CompanyLoader />}

        {!isLoading && (
          <Select
            autoFocus
            classNamePrefix="select"
            backspaceRemovesValue={false}
            components={{ DropdownIndicator: DropdownIndicatorComponent, IndicatorSeparator: null, ...(props.isIconBefore && { Option: CustomOption }), }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            menuIsOpen
            onKeyDown={e => onSearchChange(e)}
            onChange={onSelectChange}
            placeholder=""
            styles={stylesToApply}
            tabSelectsValue={false}
            value={value}
            menuShouldScrollIntoView={false}
            noOptionsMessage={() => "No results found"}
            {...props}
          />
        )}
        {!isLoading && showCustomInputOption && (
          <DropdownItem tag="div" className={cx(style["select2-custom-input-field"])}>
            <Input
              type="text"
              autoComplete="off"
              id="select2-custom-input-box"
              value={customInputValue}
              onChange={e => insertCustomInputValue(e)}
              onKeyUp={e => handleEnterPress(e)}
              placeholder="Enter a Value"
            />
            <Button
              type="button"
              className={cx({
                [style["active"]]: customInputValue?.length > 0,
                [style["disable"]]: customInputValue?.length < 1 || !customInputValue,
              })}
              onClick={updateDropdownCustomValue}>
              <Icon icon="ui-arrow-right2" additionalclass={"m-0"} />
            </Button>
          </DropdownItem>
        )}
        {props?.onAddNew && (
          <>
            <DropdownItem divider />
            <DropdownItem
              tag="div"
              onClick={props?.onAddNew}
              className={cx(
                style["d-flex"],
                style["align-items-center"],
                style["mb-2"],
                style["pl-3"],
                style["cursor-pointer"]
              )}>
              <Icon icon="ui-plus" additionalclass="mr-2" /> New
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

Select2.propTypes = {
  updateState: PropTypes.func,
  customLabel: PropTypes.bool,
  labelField: PropTypes.string,
  subField: PropTypes.string,
  name: PropTypes.string,
  defaultValue: PropTypes.object,
  isDisabled: PropTypes.bool,
  dropDownMenuClass: PropTypes.string,
};

const SelectLabel = props => {
  const buttonRef = useRef(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleMouseEnter = () => {
    if (buttonRef.current) {
      setTooltipOpen(buttonRef.current.scrollWidth > buttonRef.current.clientWidth);
    }
  };

  return (
    <>
      <div ref={buttonRef} onMouseEnter={handleMouseEnter} onMouseLeave={() => setTooltipOpen(false)}>
        {props.customLabel && (
          <span>
            <LoadFlagImage isoCode={props.buttonValue.iso_code} />{" "}
            {props.labelField ? `+${props.buttonValue[props.labelField]}` : props.buttonValue.name}
          </span>
        )}
        {!props.customLabel && props.buttonValue.name}
        {!props.customLabel && !props.buttonValue.name && props.buttonValue.firstname && props.buttonValue.lastname && (
          <span>
            {props.buttonValue.firstname} {props.buttonValue.lastname}
          </span>
        )}
      </div>
      {!props.customLabel && props.buttonValue.name && (
        <Tooltip
          isOpen={tooltipOpen}
          target={buttonRef.current}
          className={cx({ [style["item-name-tooltip"]]: props.customDropdownMenuClass?.includes("item-name") })}
          placement={"bottom-end"}>
          {props.buttonValue.name}
        </Tooltip>
      )}
    </>
  );
};

SelectLabel.propTypes = {
  customLabel: PropTypes.bool,
  buttonValue: PropTypes.object,
  labelField: PropTypes.string,
};

const DropdownIndicator = ({ manageItemLink, manageItemText, isSuperAdmin }) => {
  const history = useHistory();
  const handleSettingsClick = () => {
    if (isSuperAdmin) {
      history.push(manageItemLink);
    }
  };

  return (
    <>
      <Icon icon="ui-search" />
      {manageItemLink && (
        <div className={cx(style["settings"], style["custom-tooltip"])} onClick={handleSettingsClick}>
          <Icon icon={isSuperAdmin ? "ui-settings" : "ui-info"} />
          <div className={cx(style["custom-tooltip-content"], style["bottom"], style["mt-5"])}>{manageItemText}</div>
        </div>
      )}
    </>
  );
};

const CustomOption = (props) => {
  const { name, icon_name } = props.data;
  const iconName = icon_name || "ui-info";

  return (
    <components.Option {...props}>
      <Icon icon={iconName} style={{ marginRight: 8 }} />
      {name}
    </components.Option>
  );
};

export default Select2;
